import React from 'react';
import { UnderwriterProps } from '../../../../types/TermsTypes';

const PDFOnlyTerms: React.FC<UnderwriterProps> = (props) => <></>;

export default PDFOnlyTerms;
